<template>
  <div class="video-right">
    <video
      @pause="videoPause"
      @play="videoPlay"
      ref="myVideo"
      style="height: 100%; width: 100%;"
      :controls="videoPauseShow ? false : true"
      :controlslist="'nodownload noplaybackrate'"
      :src="src"
    ></video>
    <div
      v-if="videoPauseShow"
      class="prism-big-play-btn"
      :style="{width: statusBtnSize[0] + 'px', height: statusBtnSize[1] + 'px'}"
      @click="videoPlay">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: null
    },
    statusBtnSize: {
      type: Array,
      default: () => {
        return [64, 64]
      }
    }
  },
  data () {
    return {
      videoPauseShow: true
    }
  },
  methods: {
    videoPause () {
      this.videoPauseShow = true
    },
    videoPlay () {
      this.videoPauseShow = false
      this.$refs.myVideo.play()
    }
  }
}
</script>
<style scoped lang="scss">
  .video-right {
    height: 100%;
    width: 100%;
    background: #000;
    position: relative;
    .prism-big-play-btn {
      position: absolute;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 48%;
      /*width: 64px;*/
      /*height: 64px;*/
      background: url('../../assets/triangle.png') no-repeat;
      background-size: contain;
      cursor: pointer;
    }
  }
  //进度条
  video::-webkit-media-controls-timeline {
    display: none;
  }
  //观看的当前时间
  video::-webkit-media-controls-current-time-display {
    display: none;
  }
  //剩余时间
  video::-webkit-media-controls-time-remaining-display {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/components/video/MyVideo.vue